import React from "react";

interface BlueskyIconProps {
  size?: number;
  className?: string;
}

// Bluesky butterfly logo icon (uses currentColor)
const BlueskyIcon: React.FC<BlueskyIconProps> = ({
  size = 20,
  className = "text-white",
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden="true"
    >
      {/* Path adapted from the official Bluesky mark (simplified) */}
      <path d="M3.24 2.246c1.397 1.105 4.368 3.511 6.216 3.511 1.848 0 4.819-2.406 6.216-3.511.373-.295.571-.31.747-.28.337.058.515.342.57.476.123.301.112.664.112.664 0 3.051-1.812 4.647-3.715 6.392-1.119 1.02-1.421 1.68-1.421 2.275 0 .748.603 1.307 1.353 1.307.648 0 1.352-.2 2.25-.74-.603 1.539-2.07 2.75-3.533 2.75-1.005 0-1.782-.33-2.579-.756-.797.425-1.575.756-2.58.756-1.462 0-2.93-1.211-3.533-2.75.898.54 1.602.74 2.25.74.75 0 1.353-.559 1.353-1.307 0-.595-.302-1.255-1.421-2.275C4.488 7.753 2.676 6.157 2.676 3.106c0 0-.01-.363.112-.664.055-.134.233-.418.57-.476.176-.03.374-.015.747.28Z" />
    </svg>
  );
};

export default BlueskyIcon;
